var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-row',[_c('Map',{attrs:{"latLon":_vm.latLon,"zoom":_vm.zoom,"basemap":_vm.basemap},on:{"mapready":_vm.mapready}})],1),_vm._v(" "),_c('a-row',{staticClass:"exampleContent"},[_vm._t("content"),_vm._v(" "),_c('pre',[_c('code',[_vm._t("code")],2)])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }